// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"984e6c51","884":"e25b11be"}[chunkId] + ".chunk.js";
};